import { Controller } from "@hotwired/stimulus"
import { MODAL_ACTIONS } from "./constants"
import { openRailsuiModal, observeModalHidden } from "./report_dashboard_modal"

export default class extends Controller {
  connect() {
    if (!document.getElementById("noCourseAvailableModal")) return

    requestAnimationFrame(() => {
      this.openModalById("noCourseAvailableModal")
    })
  }

  openCourseModal(event) {
    this.invokeModalAction("openCourseModal", event)
  }

  openStudentModal(event) {
    this.invokeModalAction("openStudentModal", event)
  }

  openCaseModal(event) {
    this.invokeModalAction("openCaseModal", event)
  }

  openAssessmentsModal(event) {
    this.invokeModalAction("openAssessmentsModal", event)
  }

  invokeModalAction(action, event) {
    event?.preventDefault()

    const config = MODAL_ACTIONS[action]
    if (!config) return

    const trigger = event?.currentTarget
    this.openModalById(config.modalId, trigger)
    config.afterOpen(this, event)
  }

  modalController(identifier) {
    return this.application.getControllerForElementAndIdentifier(this.element, identifier)
  }

  openModalById(modalId, trigger = null) {
    if (!openRailsuiModal(this.application, modalId, this.element)) return

    if (!trigger) return

    this.setModalTriggerExpanded(trigger, true)

    const observer = observeModalHidden(modalId, this.element, () => {
      this.setModalTriggerExpanded(trigger, false)
      observer?.disconnect()
    })
  }

  setModalTriggerExpanded(trigger, expanded) {
    if (!trigger?.setAttribute) return

    trigger.setAttribute("aria-expanded", String(expanded))
  }
}
